/**
 * Created by khairullah.gaurab on 10/18/2018.
 */
/**
 * Default Fuse Configuration
 *
 * You can edit these options to change the default options. All these options also can be changed per component
 * basis. See `app/main/content/pages/authentication/login/login.component.ts` constructor method to learn more
 * about changing these options per component basis.
 */
export const fuseConfig = {
  layout          : {
    navigation      : 'left', // 'right', 'left', 'top', 'none'
    navigationFolded: false, // true, false
    toolbar         : 'below', // 'above', 'below', 'none'
    footer          : 'none', // 'above', 'below', 'none'
    mode            : 'fullwidth', // 'boxed', 'fullwidth'
    showCustomButton: false, // true, false
    rightPanel      : true
  },
  colorClasses    : {
    toolbar               : 'first-level-toolbar',
    navbar                : 'orbitax-navbar-bg',
    footer                : 'mat-fuse-dark-900-bg',
    collaborationSidePanel: 'mat-white-bg'
  },
  customScrollbars: true,
  routerAnimation : 'fadeIn' // fadeIn, slideUp, slideDown, slideRight, slideLeft, none
};
